import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { crmList, deleteCache } from "../apis/invoice";
import { Filter } from "../filter/Filter";
import { invoice } from "../apis/filter";
import { Invoices } from "./Invoices";
import {
  setGetValues,
  setPageNumber,
  initializeFilter,
} from "../filter/duck/actions";
import Pagination from "../common/Pagination";
import useStateIfMounted from "../hook/useStateIfMounted";
import Loading from "../common/Loading";

const SCREENNAME = "CrmInvoice";

export const CrmInvoiceList = () => {
  let selectedFilterValues = useSelector(
    (state) => state.filter.selectedFilterValues
  );
  const sort = useSelector((state) => state.filter.sort);
  const page = useSelector((state) => state.filter.page);
  const [data, setData] = useStateIfMounted([]);
  const [loading, setLoading] = useStateIfMounted(false);
  const getValues = useSelector((state) => state.filter.getValues);
  const dispatch = useDispatch();
  const sortPayload = sort.screen === SCREENNAME ? sort : {};
  const [pageCount, setPageCount] = useStateIfMounted(1);
  const selectedFilterKey = selectedFilterValues
    .map((f) => `${f.dataName}:${(f.selectedValues || []).join(",")}`)
    .join("|");

  const loadData = () => {
    dispatch(setGetValues(false));
    setLoading(true);
    crmList(selectedFilterValues, sortPayload, page.pageNumber || 0)
      .then((result) => {
        setData(result.data.list);
        setPageCount(result.data.pageCount);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (!getValues) return;
    loadData();
  }, [
    getValues,
    selectedFilterKey,
    sort.screen,
    sort.column,
    sort.direction,
    page.pageNumber,
    page.screen,
  ]);

  useEffect(() => {
    const currentPage = page && SCREENNAME === page.screen ? page : null;
    dispatch(initializeFilter(currentPage, SCREENNAME));
    deleteCache();
  }, []);

  useEffect(() => {
    const handleBeforeUnload = async () => {
      await deleteCache();
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <div className="invoice-list">
      <Filter fn={invoice} buttons={null} textFieldName="InvoiceDefinition" />
      {loading ? (
        <Loading className="big" />
      ) : (
        <>
          <Invoices data={data} loading={loading} />
          <div className="invoice-footer invoice-paginition">
            <Pagination
              pageCount={pageCount}
              pageNumber={page.pageNumber}
              setPage={(pageNumber) =>
                dispatch(setPageNumber(SCREENNAME, pageNumber))
              }
            />
          </div>
        </>
      )}
    </div>
  );
};
